'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ButtonLooks = void 0;
(function(ButtonLooks) {
    ButtonLooks["Danger"] = 'danger';
    ButtonLooks["Default"] = 'default';
    ButtonLooks["Primary"] = 'primary';
    ButtonLooks["Secondary"] = 'secondary';
    ButtonLooks["Tertiary"] = 'tertiary';
    ButtonLooks["TextSecondary"] = 'text-secondary';
    ButtonLooks["TextTertiary"] = 'text-tertiary';
    ButtonLooks["TextWarning"] = 'text-warning';
    ButtonLooks["Warning"] = 'warning';
    ButtonLooks["White"] = 'white';
})(exports.ButtonLooks || (exports.ButtonLooks = {}));
exports.ButtonSizes = void 0;
(function(ButtonSizes) {
    ButtonSizes[/** 225px */ "Large"] = 'large';
    ButtonSizes[/** 175px */ "Medium"] = 'medium';
    ButtonSizes[/** 125px */ "Small"] = 'small';
    ButtonSizes[/** 75px */ "XSmall"] = 'xsmall';
})(exports.ButtonSizes || (exports.ButtonSizes = {}));
exports.ButtonVariants = void 0;
(function(ButtonVariants) {
    ButtonVariants["Icon"] = 'icon';
    ButtonVariants["None"] = '';
    ButtonVariants["Standard"] = 'standard';
    ButtonVariants["Tile"] = 'tile';
})(exports.ButtonVariants || (exports.ButtonVariants = {}));
//# sourceMappingURL=button.js.map
